/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlogDto } from '../../models/blog-dto';

export interface ApiProductsqueryBlogsUrlIdContentGet$Plain$Params {
  urlId: number;
}

export function apiProductsqueryBlogsUrlIdContentGet$Plain(http: HttpClient, rootUrl: string, params: ApiProductsqueryBlogsUrlIdContentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BlogDto>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryBlogsUrlIdContentGet$Plain.PATH, 'get');
  if (params) {
    rb.path('urlId', params.urlId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BlogDto>;
    })
  );
}

apiProductsqueryBlogsUrlIdContentGet$Plain.PATH = '/api/productsquery/blogs/{urlId}/content';
